import React, { useEffect, useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { subscribeLoading } from '../utils/loadingBus';

export default function GlobalLoadingOverlay() {
    const [loading, setLoading] = useState(false);

    useEffect(() => subscribeLoading(setLoading), []);

    return (
        <Backdrop
            open={loading}
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
